;(() => {
  const blogArticle = document.querySelector('article.blog')

  if (blogArticle) {
    const blogArticleContent = blogArticle.querySelector('main.content')

    function addWrapperToSideBySide(htmlString) {
      const regex = /\[SIDE-BY-SIDE\](.*?)\[\/SIDE-BY-SIDE\]/gs
      const updatedHtml = htmlString.replace(regex, (_, content) => {
        //remove everything except img tags
        const filteredContent = content.replace(/<(?!img\b)[^>]*>/gi, '').trim()
        return `
          <div class="side-by-side">
            <div class="side-by-side-wrapper">
              ${filteredContent}
            </div>
          </div>`
      })
      blogArticleContent.innerHTML = updatedHtml
    }

    function wrapImagesInSizeDivs() {
      document
        .querySelectorAll('article.blog main.content img')
        .forEach((img) => {
          //don't wrap img's within a side-by-side element
          if (img.closest('.side-by-side')) return
          const imgSrc = img.getAttribute('src')
          let imgSize = '480'
          if (imgSrc?.includes('2048x2048.jpg')) {
            imgSize = '2048'
          } else if (imgSrc?.includes('1024x1024.jpg')) {
            imgSize = '1024'
          } else if (imgSrc?.includes('480x480.jpg')) {
            imgSize = '480'
          }
          let wrapper = document.createElement('div')
          wrapper.classList.add('img-wrapper', `size-${imgSize}`)
          img.parentNode.insertBefore(wrapper, img)
          wrapper.appendChild(img)
        })
    }

    function insertProductsOnBlogPage() {
      const article = document.querySelector('article.blog main.content')

      function columnCount(products_count) {
        if ([3, 5, 6].includes(products_count)) {
          return 'columns-3'
        } else {
          return 'columns-2'
        }
      }

      const placements = [
        {
          placeholder: '[P1-P1]',
          replacement: `<div class="product-placement-1 products-grid ${columnCount(
            window.limely_inline_products_1.length
          )}">${window.limely_inline_products_1.join('')}</div>`
        },
        {
          placeholder: '[P2-P2]',
          replacement: `<div class="product-placement-2 products-grid ${columnCount(
            window.limely_inline_products_2.length
          )}">${window.limely_inline_products_2.join('')}</div>`
        },
        {
          placeholder: '[P3-P3]',
          replacement: `<div class="product-placement-3 products-grid ${columnCount(
            window.limely_inline_products_3.length
          )}">${window.limely_inline_products_3.join('')}</div>`
        }
      ]

      let updatedHTML = article.innerHTML

      placements.forEach(({ placeholder, replacement }) => {
        updatedHTML = updatedHTML.split(placeholder).join(replacement)
      })

      article.innerHTML = updatedHTML
    }

    function insertImageCaptions() {
      //when an img is wrapped in a link that has a title tag, append this title tag as a figure caption
      document.querySelectorAll('article.blog a[title]').forEach((element) => {
        if (element.querySelector('img')) {
          const title = element.getAttribute('title')
          const span = document.createElement('div')
          span.className = 'img-caption'
          if (title.includes('|')) {
            span.innerHTML = `${title.split('|')[0].trim()} | <span>${title
              .split('|')[1]
              .trim()}</span>`
          } else {
            span.innerHTML = `<span>${title}</span>`
          }
          element.append(span)
        }
      })
    }

    addWrapperToSideBySide(blogArticleContent.innerHTML)
    wrapImagesInSizeDivs()
    insertProductsOnBlogPage()
    insertImageCaptions()
  }
})()
